import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const BasisAndDimension = () => (
  <QPhototModuleSubtopic
    title="Basis and Dimension"
    videos={[
      "https://www.youtube.com/embed/Vp6oYD9czps",
      "https://www.youtube.com/embed/IQS9CHIsCTg",
      "https://www.youtube.com/embed/LvG6WJYrQSg",
      "https://www.youtube.com/embed/A8nMWWAWYME"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_69.png"},
        {image:"/cvla_70.png"},
        {image:"/cvla_71.png"},
        {image:"/cvla_72.png"},
        

    ]}
    exampleVideos={[]}
  />
);

export default BasisAndDimension;
